export function isStringArray(values: unknown): values is string[] {
  return (
    Array.isArray(values) && values.every((item) => typeof item === 'string')
  );
}
